import {defaultList} from "@/utils/utils";
import {set, clone} from 'lodash';

export class MutationGenerator {
    constructor(mutation, stateName, stateNamePlural, defaultList) {
        this.mutation = mutation;
        this.stateName = stateName;
        this.stateNamePlural = stateNamePlural ? stateNamePlural : stateName + 's';
        this.stateFields = this.stateName + 'Fields';
        this.backupState = this.stateName + 'Backup';
        this.defaultList = defaultList;
    }

    generateMutations() {
        return {
            [this.mutation]: (state, element) => this.storeElement(this.stateName, state, element),
            [this.mutation + '_PROPERTY']: (state, {property, value}) => {
                set(state[this.stateName], property, value);
                state[this.stateName] = clone(state[this.stateName]);
            },
            [this.mutation + '_LIST']: (state, element) => this.storeElement(this.stateNamePlural, state, element),
            [this.mutation + '_FIELDS']: (state, element) => this.storeElement(this.stateFields, state, element),
            [this.mutation + '_BACKUP']: (state, element) => this.storeElement(this.backupState, state, element),
        };
    }

    storeElement(stateName, state, element) {
        state[stateName] = element;
    }

    generateState() {
        return {
            [this.stateName]: null,
            [this.stateNamePlural]: this.defaultList ? this.defaultList : defaultList(),
            [this.stateFields]: null,
            [this.backupState]: null,
        };
    }
}

export default [
    new MutationGenerator('STORE_USER', 'user'),
    new MutationGenerator('STORE_PATIENT', 'patient'),
    new MutationGenerator('STORE_CENTER', 'center'),
    new MutationGenerator('STORE_SURGERY_DESCRIPTION', 'surgeryDescription',
        'surgeryDescriptions', []),
    new MutationGenerator('STORE_SURGERY', 'surgery', 'surgeries'),
    new MutationGenerator('STORE_BLOOD_TEST', 'bloodTest'),
    new MutationGenerator('STORE_NOVOEIGHT_TREATMENT', 'novoeightTreatment'),
    new MutationGenerator('STORE_TRANSFUSION', 'transfusion'),
    new MutationGenerator('STORE_ADJUVANT_TREATMENT', 'adjuvantTreatment'),
    new MutationGenerator('STORE_PREVIOUS_SURGERY', 'previousSurgery', 'previousSurgeries'),
    new MutationGenerator('STORE_POST_SURGERY', 'postSurgery', 'postSurgeries'),
    new MutationGenerator('STORE_FINAL_EVALUATION', 'finalEvaluation', ),
];